import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import TickCheckbox from '../../../../components/Checkbox';
import { IconWrapper } from '../../../../components/Icon';
import { theme } from '../../../../styles/theme';

interface IProps {
  children: ReactNode;
  onClick: () => void;
  checked: boolean;
}

const Container = styled.div<{ $checked: boolean }>`
  flex: 0 0 auto;
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  column-gap: 8px;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: ${theme.colors.secondary800};
  &:hover {
    color: ${theme.colors.mainBlue};
    cursor: pointer;
  }
  ${({ $checked }) =>
    $checked &&
    css`
      color: ${theme.colors.mainBlue};
    `}
`;

const AdvancedSearchMenuOption = ({ children, onClick, checked }: IProps) => {
  return (
    <Container onClick={onClick} $checked={checked}>
      <IconWrapper size={16}>
        <TickCheckbox checked={checked} />
      </IconWrapper>
      {children}
    </Container>
  );
};

export default AdvancedSearchMenuOption;
